const template = (data) => `
<div class="alert alert--success u-mb">
    ${data}
</div>
`
export default template
